(function () {
    var root = document.querySelector('.act');
    if (!root || root.__act) return; root.__act = true;
    var mq = window.matchMedia('(max-width: 899px)');

    // video: same player as the challenge pages. YouTube runs without its own controls, the iframe is sized to
    // cover the hero shape and made taller than the video so YouTube's title/logo strips fall outside the frame,
    // the poster stays on top until playback has really started, and our own control bar replaces YouTube's.
    var ICON = {
      play: '<svg class="act-i-play" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>',
      pause: '<svg class="act-i-pause" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>',
      vol: '<svg class="act-i-vol" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/><path d="M19 6a8.5 8.5 0 0 1 0 12"/></svg>',
      muted: '<svg class="act-i-muted" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h4l5 4V5L8 9z"/><path d="m17 9 5 6M22 9l-5 6"/></svg>',
      fs: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>'
    };
    function loadApi(cb) {
      if (window.YT && window.YT.Player) return cb();
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) prev(); cb(); };
      if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
        var s = document.createElement('script'); s.src = 'https://www.youtube.com/iframe_api'; document.head.appendChild(s);
      }
    }
    root.querySelectorAll('[data-video]').forEach(function (box) {
      var id = box.getAttribute('data-video'), playBtn = box.querySelector('[data-play]');
      if (!id || !playBtn) return;
      var frame = document.createElement('div'); frame.className = 'act-vid__frame';
      box.insertBefore(frame, box.firstChild);
      var bar = document.createElement('div'); bar.className = 'act-vid__bar'; bar.hidden = true;
      bar.innerHTML = '<button type="button" class="act-vid__btn act-vid__btn--main" aria-label="Play">' + ICON.play + ICON.pause + '</button>' +
        '<input type="range" class="act-vid__seek" min="0" max="1000" value="0" step="1" aria-label="Seek">' +
        '<button type="button" class="act-vid__btn" aria-label="Mute">' + ICON.vol + ICON.muted + '</button>' +
        ((box.requestFullscreen || box.webkitRequestFullscreen) ? '<button type="button" class="act-vid__btn" aria-label="Full screen">' + ICON.fs + '</button>' : '');
      box.appendChild(bar);
      var btns = bar.querySelectorAll('button'), toggleBtn = btns[0], muteBtn = btns[1], fsBtn = btns[2], seek = bar.querySelector('input');
      var player = null, ready = false, wantPlay = false, ticker = null, idleTimer = null, revealTimer = null, seeking = false;

      function isFull() { return (document.fullscreenElement || document.webkitFullscreenElement) === box; }
      function fit() {
        var W = box.clientWidth, H = box.clientHeight; if (!W || !H) return;
        var vw = isFull() ? Math.min(W, H * 16 / 9) : Math.max(W, H * 16 / 9), vh = vw * 9 / 16, pad = Math.round(vh * 0.26);
        frame.style.left = Math.round((W - vw) / 2) + 'px'; frame.style.width = Math.round(vw) + 'px';
        frame.style.top = Math.round((H - vh) / 2 - pad) + 'px'; frame.style.height = Math.round(vh + 2 * pad) + 'px';
      }
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(box); else addEventListener('resize', fit);
      document.addEventListener('fullscreenchange', fit); document.addEventListener('webkitfullscreenchange', fit);

      function setState(s) {
        box.classList.toggle('is-playing', s === 'playing');
        box.classList.toggle('is-paused', s !== 'playing');
        if (s === 'held') box.classList.add('is-held'); else if (s === 'ended') box.classList.remove('is-held');
        toggleBtn.setAttribute('aria-label', s === 'playing' ? 'Pause' : 'Play');
      }
      function tick() {
        if (!player || !ready || seeking) return;
        var d = player.getDuration() || 0, t = player.getCurrentTime() || 0, p = d ? t / d * 100 : 0;
        seek.value = Math.round(p * 10); seek.style.setProperty('--p', p + '%');
      }
      function poke() {
        box.classList.remove('is-idle'); clearTimeout(idleTimer);
        idleTimer = setTimeout(function () { if (box.classList.contains('is-playing')) box.classList.add('is-idle'); }, 2500);
      }
      function create() {
        var el = document.createElement('div'); frame.appendChild(el); fit();
        player = new YT.Player(el, {
          host: 'https://www.youtube-nocookie.com', videoId: id,
          playerVars: { autoplay: 1, controls: 0, disablekb: 1, fs: 0, rel: 0, modestbranding: 1, iv_load_policy: 3, playsinline: 1, cc_load_policy: 0, hl: 'en' },
          events: {
            onReady: function (e) {
              ready = true;
              var f = e.target.getIframe(); f.setAttribute('title', playBtn.getAttribute('aria-label') || 'Video'); f.setAttribute('tabindex', '-1');
              try { e.target.unloadModule('captions'); e.target.unloadModule('cc'); } catch (err) {}
              if (wantPlay) e.target.playVideo();
            },
            onStateChange: function (e) {
              var S = YT.PlayerState;
              if (e.data === S.PLAYING) {
                box.classList.remove('is-loading'); bar.hidden = false; clearTimeout(revealTimer);
                if (box.classList.contains('is-held')) setState('playing');
                else revealTimer = setTimeout(function () { if (player.getPlayerState() === S.PLAYING) setState('playing'); }, 700);
                if (!ticker) ticker = setInterval(tick, 250);
                poke();
              } else if (e.data === S.PAUSED) {
                clearTimeout(revealTimer); setState(player.getCurrentTime() > 0 ? 'held' : 'paused');
              } else if (e.data === S.ENDED) {
                setState('ended'); seek.value = 1000; seek.style.setProperty('--p', '100%');
              }
            }
          }
        });
      }
      function play() {
        wantPlay = true;
        if (player && ready) { player.playVideo(); return; }
        if (!player) { box.classList.add('is-loading', 'is-started'); bar.hidden = false; setState('paused'); loadApi(create); }
      }
      function toggle() { if (box.classList.contains('is-playing')) { if (player && ready) player.pauseVideo(); } else play(); }

      playBtn.addEventListener('click', function (e) { e.stopPropagation(); play(); });
      toggleBtn.addEventListener('click', toggle);
      box.addEventListener('click', function (e) { if (!e.target.closest('button, input, .act-vid__bar') && box.classList.contains('is-started')) toggle(); });
      box.addEventListener('mousemove', poke); box.addEventListener('touchstart', poke, { passive: true }); box.addEventListener('focusin', poke);
      seek.addEventListener('input', function () { seeking = true; seek.style.setProperty('--p', seek.value / 10 + '%'); });
      seek.addEventListener('change', function () {
        seeking = false; if (!player || !ready) return;
        player.seekTo(seek.value / 1000 * (player.getDuration() || 0), true);
        if (!box.classList.contains('is-playing')) player.playVideo();
      });
      muteBtn.addEventListener('click', function () {
        if (!player || !ready) return;
        if (player.isMuted()) { player.unMute(); box.classList.remove('is-muted'); muteBtn.setAttribute('aria-label', 'Mute'); }
        else { player.mute(); box.classList.add('is-muted'); muteBtn.setAttribute('aria-label', 'Unmute'); }
      });
      if (fsBtn) fsBtn.addEventListener('click', function () {
        if (isFull()) return (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        (box.requestFullscreen || box.webkitRequestFullscreen).call(box);
      });
      box.addEventListener('keydown', function (e) { if (e.target !== seek && (e.key === ' ' || e.key === 'k') && player) { e.preventDefault(); toggle(); } });
    });

    // collapsible sections: desktop starts with only the first one open, mobile starts all collapsed.
    // The whole collapsed card is clickable (the button's hit area is stretched over it in CSS).
    var steps = root.querySelectorAll('[data-step]');
    function setStep(s, open) {
      s.classList.toggle('is-closed', !open);
      var b = s.querySelector('[data-step-toggle]'), t = s.querySelector('.act-step__t');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.setAttribute('aria-label', (open ? 'Collapse ' : 'Expand ') + (t ? t.textContent : 'section'));
    }
    steps.forEach(function (s, i) {
      setStep(s, !mq.matches && i === 0);
      s.querySelector('[data-step-toggle]').addEventListener('click', function () { setStep(s, s.classList.contains('is-closed')); });
    });

    // sticky sidebar: if it's taller than the screen, let it stick by its bottom edge so every card can be reached
    var side = root.querySelector('.act-side');
    function sticky() {
      if (!side || mq.matches) return;
      var cs = getComputedStyle(document.documentElement);
      var top = (parseFloat(cs.getPropertyValue('--sticky-header-enabled')) ? parseFloat(cs.getPropertyValue('--header-height')) || 0 : 0) + 24;
      var h = side.offsetHeight;
      side.style.top = (h + top + 24 > innerHeight ? Math.min(top, innerHeight - h - 24) : top) + 'px';
    }
    if (side && 'ResizeObserver' in window) new ResizeObserver(sticky).observe(side);
    addEventListener('resize', sticky); sticky();

    // educational standards: all collapsed to start, one framework open at a time
    root.querySelectorAll('[data-std]').forEach(function (card) {
      var hs = card.querySelectorAll('[data-std-toggle]');
      function open(h, on) { h.setAttribute('aria-expanded', on ? 'true' : 'false'); h.nextElementSibling.hidden = !on; }
      hs.forEach(function (h) {
        h.addEventListener('click', function () {
          var was = h.getAttribute('aria-expanded') === 'true';
          hs.forEach(function (o) { open(o, false); });
          if (!was) open(h, true);
        });
      });
    });

    // materials checklist: just for this visit. It starts empty every time the page is opened,
    // including when the browser brings the page back with the Back/Forward buttons.
    var mat = root.querySelector('[data-mat]');
    if (mat) {
      function clearMat() { mat.querySelectorAll('input').forEach(function (i) { i.checked = false; }); }
      mat.querySelectorAll('input').forEach(function (i) { i.setAttribute('autocomplete', 'off'); });
      clearMat();
      addEventListener('pageshow', clearMat);
      try { localStorage.removeItem('clixo-act-materials-' + root.getAttribute('data-article')); } catch (e) {}
    }

    // mobile carousels with dots
    root.querySelectorAll('[data-rail]').forEach(function (rail) {
      var dots = rail.parentElement.querySelector('[data-dots]');
      var cards = rail.children;
      if (!dots || cards.length < 2) return;
      for (var k = 0; k < cards.length; k++) {
        var d = document.createElement('button');
        d.type = 'button'; d.setAttribute('aria-label', 'Show card ' + (k + 1));
        d.setAttribute('aria-current', k === 0 ? 'true' : 'false');
        (function (k) { d.addEventListener('click', function () { rail.scrollTo({ left: cards[k].offsetLeft - cards[0].offsetLeft, behavior: 'smooth' }); }); })(k);
        dots.appendChild(d);
      }
      dots.removeAttribute('aria-hidden');
      function update() {
        var best = 0, bd = Infinity;
        for (var k = 0; k < cards.length; k++) { var dd = Math.abs(cards[k].offsetLeft - cards[0].offsetLeft - rail.scrollLeft); if (dd < bd) { bd = dd; best = k; } }
        dots.querySelectorAll('button').forEach(function (b, k) { b.setAttribute('aria-current', k === best ? 'true' : 'false'); });
      }
      rail.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    });
  })();
